"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _Animated = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Animated"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _skeleton = require("./skeleton.constant");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useSkeletonNativeAnimation = _ref => {
  let {
    animationDuration
  } = _ref;
  const fadeAnimation = (0, _react.useRef)(new _Animated.default.Value(_skeleton.DEFAULT_OPACITY)).current;

  /* eslint-disable react-hooks/exhaustive-deps */
  (0, _react.useEffect)(() => {
    const fade = _Animated.default.sequence([_Animated.default.timing(fadeAnimation, {
      toValue: _skeleton.OPACITY_STOP,
      duration: animationDuration,
      useNativeDriver: _Platform.default.OS !== 'web'
    }), _Animated.default.timing(fadeAnimation, {
      toValue: _skeleton.DEFAULT_OPACITY,
      duration: animationDuration,
      useNativeDriver: _Platform.default.OS !== 'web'
    })]);
    _Animated.default.loop(fade).start();
  }, [fadeAnimation]);
  return {
    opacity: fadeAnimation
  };
};
var _default = exports.default = useSkeletonNativeAnimation;